import styled, { css } from 'styled-components'
import { generateMedia } from 'styled-media-query'

const media = generateMedia({
  xs: '400px',
  sm: '550px',
  md: '768px',
  lg: '1200px',
})
export const MenuStyle:any = {
  left: '10',
  top: '10',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  borderRadius: '10px',
  boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.1)',
  background: '#FFFFFF',
  padding: '15px 14px',
  fontSize: '50%',
  position: 'absolute',
  overflowY: 'scroll',
  height: 'auto',
  heightMax: '200%',
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '17px',
  color: '#000000',
  gap: '11px',
}
export const WrapperAutocomplete:any = {

  width: '100%',

}
export const MenuItemStyle = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '17px',
  lineHeight: '17px',
  color: '#000000',

}
export const Wrapper = styled.div`
  ${({ theme }) => css`
      width:100%;
      
    input {
      border: 1px solid ${theme.colors.lightGray};
      display: block;
      width: 100%;
      height: 48px;
      --BaseFontSize: 1rem;
      font-size: var(--BaseFontSize);
      padding: 0.6rem;
      border-radius: ${theme.border.xradius};
      background: ${theme.colors.white};
      transition: 0.2s;
      appearance: none;
      cursor: pointer;
      ${media.between('sm', 'md')`
      font-size: calc(var(--BaseFontSize) / 1.5625);
      `}
      ${media.between('xs', 'sm')`
      font-size: calc(var(--BaseFontSize) /1.5625);
      `}
      ${media.lessThan('xs')`
      font-size: calc(var(--BaseFontSize)/1.581);
      `}
      &:hover {
        outline: none;
        border-color: ${theme.colors.secondary};
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
      }

    }

    label {
      display: block;
      margin-top: 1rem;
      margin-left: 6px;
      padding-bottom: 0.3rem;
      font-family: 'Montserrat';
      font-style: normal;
      --BaseFontWeight: 600;
      --BaseFontSize: 17px;
      --BaselineHeight: 17px;
      font-weight:var(--BaseFontWeight);
      font-size: var(--BaseFontSize);
      line-height: var(--BaselineHeight);
      ${media.between('sm', 'md')`
      font-size: calc(var(--BaseFontSize) / 1,2625);
      line-height: calc(var(--BaselineHeight) 1,2625);
      `}
      ${media.between('xs', 'sm')`
      font-size: calc(var(--BaseFontSize) 1.781);
      line-height: calc(var(--BaselineHeight) 1.781);
      `}
      ${media.lessThan('xs')`
      font-size: calc(var(--BaseFontSize)/1.728);
      line-height: calc(var(--BaselineHeight)/1.728);
      `}

    }
    
  `}
`
